// extracted by mini-css-extract-plugin
module.exports =  {"pagination":"_02712f2b3b--pagination--SIf_R","pages-list":"_02712f2b3b--pages-list--OcUXj","page":"_02712f2b3b--page--Gby6K"};